import * as React from "react";
import { AgGridReact, Button, Classes, Dialog, InputGroup, Intent, } from "@focus/focusUI";
import { CustomHeader } from "./CustomHeader";
import "@focus/focusUI/lib/style.scss";
import "./ListTable.scss";
import { FocusFormValidator } from "../form/FocusFormValidator";
import { buildHeaders, checkNumberLength, setNumberToLength, } from "../utils/utils";
import { computeFormula } from "../entities/formula";
export const ListTable = ({ items, onGridReady, uiSchema, formData, onRowSelect, onRowDoubleClick, disableHeaderEdition, setFieldColumn, onFirstDataRendered, }) => {
    const [quickFilterText, setQuickFilterText] = React.useState(null);
    const [isOpenDialog, setIsOpenDialog] = React.useState(false);
    const [headerState, setHeaderState] = React.useState(undefined);
    const [selectedColumn, setSelectedColumn] = React.useState(null);
    const gridRef = React.useRef();
    const formDataWithId = React.useMemo(() => {
        return formData.map((item, index) => {
            const newItem = checkNumberLength(item, items);
            return Object.assign(Object.assign({}, newItem), { id: index });
        });
    }, [formData]);
    const quickSearch = (e) => {
        setQuickFilterText(e.target.value);
    };
    const handleRowSelect = React.useCallback(() => {
        onRowSelect(gridRef);
    }, []);
    const handleRowDoubleClick = React.useCallback((e) => {
        onRowDoubleClick(parseInt(e.source.rowNode.id));
    }, []);
    const buildArrayCell = (formData, def) => {
        let text = "[";
        const data = typeof formData !== "undefined" ? formData : def;
        if (Array.isArray(data) && data.length > 0) {
            text += data[0];
            for (let i = 1; i < data.length; i++) {
                text += ", " + data[i];
            }
            text += "]";
        }
        else {
            text = "[]";
        }
        return text;
    };
    const buildMatrixCell = (formData, def) => {
        let prevText = "[";
        let finalText = "";
        const data = typeof formData !== "undefined" ? formData : def;
        if (Array.isArray(data) && data.length > 0) {
            data.forEach((array) => (prevText += "[" + array.toString() + "]"));
            finalText = prevText.slice(0, -1) + "]";
        }
        else {
            finalText = "[][]";
        }
        return finalText;
    };
    const buildMenuCell = (formData, def) => {
        const text = typeof formData !== "undefined" ? formData : def;
        return text;
    };
    const enumKeySearcher = (value) => (element) => element == value;
    const getMenuLabel = (menuProps, menuData) => {
        return menuProps.enumNames[menuProps.enum.findIndex(enumKeySearcher(menuData))];
    };
    const buildNumericCell = (formData, def, schema) => {
        const text = typeof formData !== "undefined" && formData !== null
            ? formData.toString() === ""
                ? def
                : (schema.maxLength
                    ? setNumberToLength(Number(formData), schema.maxLength)
                    : formData).toString()
            : def;
        return text;
    };
    const buildBooleanCell = (formData, def) => {
        const text = typeof formData !== "undefined" && formData !== null
            ? formData.toString() === ""
                ? def
                : formData.toString()
            : def;
        return text;
    };
    const buildStringCell = (formData, def) => {
        const text = typeof formData !== "undefined" && formData !== null
            ? formData.toString() === ""
                ? def
                : formData.toString()
            : def;
        return text;
    };
    const handleData = (schema) => (params) => {
        let cellData;
        let fieldType;
        const data = [];
        const parseData = (data, fieldType) => {
            if (fieldType !== undefined && fieldType === "epochselfield") {
                return data["dateTime"];
            }
            else if (fieldType !== undefined && fieldType === "intervalfield") {
                return (data.start.modifier +
                    " " +
                    data.start.dateTime +
                    " - " +
                    data.end.modifier +
                    " " +
                    data.end.dateTime);
            }
            else if (fieldType !== undefined && fieldType === "listfield") {
                return "List";
            }
            else if (fieldType !== undefined && fieldType === "arrayfield") {
                return buildArrayCell(data, []);
            }
            else if (fieldType !== undefined && fieldType === "menufield") {
                return buildMenuCell(data, 0);
            }
            else if (fieldType !== undefined && fieldType === "matrixfield") {
                return buildMatrixCell(data, [[]]);
            }
            else if (fieldType !== undefined && fieldType === "yesnofield") {
                return buildBooleanCell(data, false);
            }
            else if (fieldType !== undefined &&
                (fieldType === "numericfield" || fieldType === "mjdfield")) {
                return buildNumericCell(data, 0.0, schema);
            }
            else if (fieldType !== undefined && fieldType === "passwordfield") {
                return new Array(data.length + 1).join("*");
            }
            else if (fieldType !== undefined && fieldType === "derivativefield") {
                const formula = (schema === null || schema === void 0 ? void 0 : schema.formula) ? schema.formula : undefined;
                return computeFormula(params.data, formula).toString();
            }
            else {
                return buildStringCell(data, "");
            }
        };
        const paramsDataWithoutId = Object.assign({}, params.data);
        delete paramsDataWithoutId.id;
        for (const key in paramsDataWithoutId) {
            if (uiSchema[key] && uiSchema[key]["ui:field"] === "tabfield") {
                for (const subkey in params.data[key]) {
                    if (uiSchema[key][subkey]["ui:field"] === "separator") {
                        if (params.data[key][subkey].hasOwnProperty(params.column.colDef.field)) {
                            fieldType = uiSchema[key][subkey][params.column.colDef.field]["ui:password"]
                                ? "passwordfield"
                                : uiSchema[key][subkey][params.column.colDef.field]["ui:field"];
                            cellData = params.data[key][subkey][params.column.colDef.field];
                            if (fieldType !== undefined && fieldType === "menufield") {
                                data.push(getMenuLabel(items.properties[key].properties[subkey].properties[params.column.colDef.field], cellData));
                                return getMenuLabel(items.properties[key].properties[subkey].properties[params.column.colDef.field], cellData);
                            }
                            else {
                                data.push(parseData(cellData, fieldType));
                                return parseData(cellData, fieldType);
                            }
                        }
                    }
                    else {
                        if (params.data[key].hasOwnProperty(params.column.colDef.field)) {
                            fieldType = uiSchema[key][params.column.colDef.field]["ui:password"]
                                ? "passwordfield"
                                : uiSchema[key][params.column.colDef.field]["ui:field"];
                            cellData = params.data[key][params.column.colDef.field];
                            if (fieldType !== undefined && fieldType === "menufield") {
                                data.push(getMenuLabel(items.properties[key].properties[params.column.colDef.field], cellData));
                                return getMenuLabel(items.properties[key].properties[params.column.colDef.field], cellData);
                            }
                            else {
                                data.push(parseData(cellData, fieldType));
                                return parseData(cellData, fieldType);
                            }
                        }
                    }
                }
            }
            else if (uiSchema[key]["ui:field"] === "separator") {
                if (params.data[key].hasOwnProperty(params.column.colDef.field)) {
                    fieldType = uiSchema[key][params.column.colDef.field]["ui:password"]
                        ? "passwordfield"
                        : uiSchema[key][params.column.colDef.field]["ui:field"];
                    cellData = params.data[key][params.column.colDef.field];
                    if (fieldType !== undefined && fieldType === "menufield") {
                        data.push(getMenuLabel(items.properties[key].properties[params.column.colDef.field], cellData));
                        return getMenuLabel(items.properties[key].properties[params.column.colDef.field], cellData);
                    }
                    else {
                        data.push(parseData(cellData, fieldType));
                        return parseData(cellData, fieldType);
                    }
                }
            }
            else {
                if (params.data.hasOwnProperty(params.column.colDef.field)) {
                    fieldType = uiSchema[params.column.colDef.field]["ui:password"]
                        ? "passwordfield"
                        : uiSchema[params.column.colDef.field]["ui:field"];
                    cellData = params.data[params.column.colDef.field];
                    if (fieldType !== undefined && fieldType === "menufield") {
                        data.push(getMenuLabel(items.properties[params.column.colDef.field], cellData));
                        return getMenuLabel(items.properties[params.column.colDef.field], cellData);
                    }
                    else {
                        data.push(parseData(cellData, fieldType));
                        return parseData(cellData, fieldType);
                    }
                }
            }
        }
    };
    const headerProps = {
        setIsOpenDialog,
        setSelectedColumn,
        disableHeaderEdition,
    };
    const { columnsData, colDefs } = React.useMemo(() => buildHeaders(uiSchema, items, formData, handleData, headerProps), [uiSchema, formData, headerProps["disableHeaderEdition"]]);
    const defaultColDef = React.useMemo(() => ({ editable: false, resizable: true }), []);
    const frameworkComponents = React.useMemo(() => ({ CustomHeader: CustomHeader }), []);
    const isReadOnly = uiSchema["ui:readOnly"];
    const isDisabled = uiSchema["ui:disabled"];
    const divClass = isReadOnly || isDisabled
        ? "listtable-div listtable-div-disabled ag-theme-balham"
        : "listtable-div ag-theme-balham";
    const getRowId = React.useMemo(() => {
        return (params) => params.data.id;
    }, []);
    const setGridSize = () => {
        const scrollbar = document.getElementsByClassName("ag-body-horizontal-scroll");
        const scrollbarHeight = scrollbar[0] !== undefined ? scrollbar[0].clientHeight : 0;
        const baseGridHeight = 32 + scrollbarHeight;
        const defaultRows = 15;
        const defaultRowHeight = 28;
        if (uiSchema["ui:height"]) {
            return baseGridHeight + uiSchema["ui:height"] * defaultRowHeight + "px";
        }
        else {
            return baseGridHeight + defaultRows * defaultRowHeight + "px";
        }
    };
    return (React.createElement("div", { className: divClass, style: { height: setGridSize() } },
        React.createElement("div", { className: "listtable-filter" },
            React.createElement(InputGroup, { disabled: false, leftIcon: "filter", onChange: quickSearch })),
        React.createElement(AgGridReact, { ref: gridRef, defaultColDef: defaultColDef, columnDefs: colDefs, rowData: formDataWithId, rowSelection: "multiple", suppressClickEdit: true, onRowClicked: handleRowSelect, onRowDoubleClicked: handleRowDoubleClick, quickFilterText: quickFilterText, onGridReady: onGridReady, onFirstDataRendered: onFirstDataRendered, suppressScrollOnNewData: true, components: frameworkComponents, getRowId: getRowId, rowHeight: 28 }),
        React.createElement(Dialog, { title: "Field to be setted", isOpen: isOpenDialog, onClose: () => setIsOpenDialog(false), style: { width: "auto", minWidth: "50vw" }, canOutsideClickClose: false, isCloseButtonShown: false },
            React.createElement("div", { className: Classes.DIALOG_BODY, style: { width: "70%" } }, selectedColumn !== null && !columnsData.data.includes(undefined) ? (React.createElement(React.Fragment, null,
                React.createElement(FocusFormValidator, { uiSchema: columnsData.uiSchema[selectedColumn], formData: headerState ? headerState : columnsData.data[selectedColumn], schema: columnsData.schema[selectedColumn], needsDefaults: true, readOnly: disableHeaderEdition, onChange: setHeaderState }),
                React.createElement("div", { className: Classes.DIALOG_FOOTER },
                    React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                        React.createElement(Button, { intent: Intent.SUCCESS, disabled: disableHeaderEdition, onClick: () => {
                                setFieldColumn(headerState
                                    ? headerState
                                    : columnsData.data[selectedColumn]);
                            } }, "Set field for all rows."),
                        React.createElement(Button, { intent: Intent.NONE, onClick: () => {
                                setIsOpenDialog(false);
                                setHeaderState(undefined);
                            } }, "Close"))))) : (React.createElement(React.Fragment, null,
                React.createElement("p", null, "No data available"),
                React.createElement(Button, { intent: Intent.NONE, onClick: () => {
                        setIsOpenDialog(false);
                    } }, "Close")))))));
};
export const ListTableWrapper = ({ items, uiSchema, formData, onGridReady, onRowSelect, onRowDoubleClick, setFieldColumn, disableHeaderEdition, onFirstDataRendered, }) => {
    const onRowDoubleClickMemo = React.useCallback((index) => {
        onRowDoubleClick(index);
    }, []);
    const onGridReadyMemo = React.useCallback((params) => {
        onGridReady(params);
    }, []);
    const uiSchemaMemo = React.useMemo(() => uiSchema, []);
    const itemsMemo = React.useMemo(() => items, []);
    return (React.createElement(ListTable, { items: itemsMemo, uiSchema: uiSchemaMemo, formData: formData, onRowSelect: onRowSelect, onRowDoubleClick: onRowDoubleClickMemo, onGridReady: onGridReadyMemo, disableHeaderEdition: disableHeaderEdition, setFieldColumn: setFieldColumn, onFirstDataRendered: onFirstDataRendered }));
};
//# sourceMappingURL=ListTable.js.map